import UserCard from '@/components/UserCard'
import Vue from 'vue'
import appConfig from '@/config.js'
import { getCountries } from '@/services/country'

const codPaymentsModel = vm => ({
  title: vm.$gettext('COD Payments'),
  endpoint: 'cod-payments',
  noIdLink: true,
  countrizeById: 'country_id',
  fields: [
    {
      key: 'id'
    },
    {
      key: 'platform_id',
      label: vm.$gettext('Platform'),
      formatter: (value, key, item) => {
        return item.platform.name
      }
    },
    {
      key: 'user_id',
      label: vm.$gettext('User'),
      formatter: (value, key, item) => {
        return new Vue({
          ...UserCard,
          parent: this,
          propsData: {
            user: item.user,
            profilePicture: false,
            withTitles: false,
            withMap: false
          }
        }).$mount().$el.outerHTML
      }
    },
    {
      key: 'external_transaction_id',
      label: vm.$gettext('Ext. Trans. ID')
    },
    {
      key: 'amount',
      label: vm.$gettext('Amount')
    },
    {
      key: 'deposited_amount',
      label: vm.$gettext('Deposited Amount')
    },
    {
      key: 'status',
      label: vm.$gettext('Status'),
      formatter: (value, key, item) => {
        let color = 'info'
        if (value === 'incidence') {
          color = 'warning'
        } else if (value !== 'pending') {
          color = 'success'
        }
        return (
          '<span class="text-' +
          color +
          ' text-nowrap"><span style="display: inline-block; width:5px; height:5px; border-radius: 100px; vertical-align:middle;" class="bg-' +
          color +
          '"></span> ' +
          value +
          '</span>'
        )
      }
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference')
    },
    {
      key: 'transactions',
      label: vm.$gettext('Transactions'),
      formatter: (value, key, item) => {
        return (
          '<a href=/list/cod-transactions?s=%5B%5B"id","in",' +
          JSON.stringify(value.map(x => x.id)) +
          '%5D%5D>' +
          vm.$gettextInterpolate(vm.$gettext('%{qty} transaction/s'), { qty: value.length }) +
          '</a>'
        )
      }
    },
    {
      key: 'picture_url',
      label: vm.$gettext('Picture'),
      formatter: (value, key, item) => {
        if (value) {
          return (
            '<a href="' +
            value +
            '" target="_blank"><img src="' +
            value +
            '" style="height: auto; width: auto; max-height: 80px; max-width: 80px;" /></a>'
          )
        }
      }
    },
    {
      key: 'country_id',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: true,
      formatter: (value, key, item) => {
        return getCountries().find(x => x.id === value).iso_code
      }
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true
    }
  ],
  extraActions: [
    {
      label: vm.$gettext('Close'),
      type: 'button',
      icon: 'check',
      title: vm.$gettext('Close an Incidence after treat it'),
      variant: 'dark',
      position: 'end',
      disabledCondition: item => {
        return item.status !== 'incidence'
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to CLOSE the COD Payment Incidence?'))) {
          Vue.http.put(appConfig.api.baseUrl + 'cod-payments/' + item.id + '/close').then(response => {
            window.moovaAdmin.refreshTable('apiListTable')
          })
        }
      }
    },
    {
      label: vm.$gettext('Discard'),
      type: 'button',
      icon: 'trash-alt',
      title: vm.$gettext('Discard a COD payment'),
      variant: 'danger',
      position: 'end',
      disabledCondition: item => {
        return item.status !== 'pending'
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to DISCARD the COD Payment?'))) {
          Vue.http.delete(appConfig.api.baseUrl + 'cod-payments/' + item.id + '/discard').then(response => {
            window.moovaAdmin.refreshTable('apiListTable')
          })
        }
      }
    }
  ],
  includes: ['user.roles', 'platform', 'transactions'],
  filters: ['id', 'user.name', 'user.email', 'status', 'updated_at']
})

export default codPaymentsModel
